module.exports = __webpack_public_path__ + "static/media/16.4079bbe7.png";